__turbopack_context__.v({
  "container": "QNo23G_container",
  "icon": "QNo23G_icon",
  "iconChevron": "QNo23G_iconChevron",
  "iconChevronContainer": "QNo23G_iconChevronContainer",
  "isActive": "QNo23G_isActive",
  "withSubMenu": "QNo23G_withSubMenu",
});
